<template>
  <div>
    <right-panel class="float-right" id="sidebar-inventory-bulk-update" width="1300px" @hidden="rightPanelClosed">
      <BulkUpdateView v-if="atLeastShow" />
    </right-panel>
    <!---->

    <sweet-button @click="toggleSidebar()" :disabled="isOrganizationBulkUpdating" variant="primary" icon="bx bx-cog" size="sm" buttonClass="mt-2 mr-2">
      <span v-if="!isOrganizationBulkUpdating">
        {{ $t("inventory.bulk-update.text") }}
      </span>
      <span v-else>
        {{ $t("inventory.bulk-update.409") }}
      </span>
    </sweet-button>
  </div>
</template>

<script>
import BulkUpdateView from "./bulk-update-view";

export default {
  components: {
    BulkUpdateView,
  },

  data() {
    return {
      atLeastShow: false,
    };
  },
  computed: {
    isOrganizationBulkUpdating() {
      return !!this.currentOrganization?.isBulkUpdating;
    },
  },

  methods: {
    toggleSidebar() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-inventory-bulk-update");
      setTimeout(() => (this.atLeastShow = true), 100);
    },
    rightPanelClosed() {},
  },
};
</script>
